import React from 'react';
import PropTypes from 'prop-types';
import { Container } from './styles';

const TextArea = ({
  value,
  error,
  onChange,
  label,
  placeholder,
  id,
  ...props
}) => {
  return (
    <Container error={error}>
      <label htmlFor={id}>{label}</label>
      <textarea
        data-testid="textArea"
        {...props}
        id={id}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
      />
      {error && <span data-testid="validator">{error}</span>}
    </Container>
  );
};

TextArea.propTypes = {
  label: PropTypes.string,
  placeholder: PropTypes.string,
  id: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  error: PropTypes.string,
};

TextArea.defaultProps = {
  placeholder: 'Placeholder',
  label: 'Label',
  id: 'name',
  error: null,
  value: '',
  onChange: (event) => event,
};

export default TextArea;
